import PropTypes from 'prop-types'
import { OptionCardStyled, OptionText } from './styled-components'
import OptionIconComponent from '@/containers/SubscriptionFormPageNew/Components/CreateContractModal/OptionIconComponent'
import useCreateContractModalStyles from './useCreateContractModalStyles'

const OptionCard = ({ hidden, onClick, selected, text, iconName }) => {
  const { isPulse } = useCreateContractModalStyles()
  if (hidden) {
    return null
  }
  return (
    <OptionCardStyled onClick={onClick} $pulse={isPulse} $selected={selected}>
      <OptionIconComponent iconName={iconName} alt={text} />
      <OptionText $pulse={isPulse} $selected={selected}>
        {text}
      </OptionText>
    </OptionCardStyled>
  )
}

OptionCard.propTypes = {
  hidden: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
}

export default OptionCard
